module.exports = __webpack_public_path__ + "static/media/HM.c581a938.svg";